import React from 'react';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { WhatIsCLVN } from '../components/WhatIsCLVN';
import { Applications } from '../components/Applications';
import { VisualEngine } from '../components/VisualEngine';
import { Timeline } from '../components/Timeline';
import { Papers } from '../components/Papers';
import { Author } from '../components/Author';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="flex flex-col w-full" data-id="element-245">
      <Nav data-id="element-246" />
      <main data-id="element-247">
        <Hero data-id="element-248" />
        <div id="marco" data-id="element-249">
          <WhatIsCLVN data-id="element-250" />
        </div>
        <div id="aplicaciones" data-id="element-251">
          <Applications data-id="element-252" />
        </div>
        <div id="motor" data-id="element-253">
          <VisualEngine data-id="element-254" />
        </div>
        <div id="timeline" data-id="element-255">
          <Timeline data-id="element-256" />
        </div>
        <div id="papers" data-id="element-257">
          <Papers data-id="element-258" />
        </div>
        <div id="autor" data-id="element-259">
          <Author data-id="element-260" />
        </div>
        <div id="contacto" data-id="element-261">
          <Contact data-id="element-262" />
        </div>
      </main>
      <Footer data-id="element-263" />
    </div>;
}